/**
 * BRISTM – Case study (single): ARIA tabs (showcase + Services/Industries
 * switch), sticky sidebar offset, hero video that plays only while visible.
 * Idempotent; re-inits on shopify:section:load.
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Tabs ---------- */
  function initTabs(group) {
    if (group.dataset.bCdBound) return;
    group.dataset.bCdBound = '1';
    var list = group.querySelector('[role="tablist"]');
    if (!list) return;
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));

    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (!panel) return;
        panel.classList.toggle('is-active', on);
        if (on) {
          panel.removeAttribute('aria-hidden');
          panel.inert = false;
        } else {
          panel.setAttribute('aria-hidden', 'true');
          panel.inert = true;
        }
      });
      if (focus) tab.focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        select(tab, false);
      });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) {
          e.preventDefault();
          select(next, true);
        }
      });
    });
  }

  /* ---------- Sticky sidebar ----------
   * When the sidebar is taller than the viewport, a negative top lets it
   * scroll until its bottom is visible and then stick there. */
  function initAside(section) {
    var aside = section.querySelector('[data-b-cd-aside]');
    if (!aside || aside.dataset.bCdBound || !('ResizeObserver' in window)) return;
    aside.dataset.bCdBound = '1';
    var desktop = window.matchMedia('(min-width: 1200px)');
    var frame = 0;

    function measure() {
      frame = 0;
      if (!desktop.matches) {
        aside.style.removeProperty('--cd-top');
        return;
      }
      var base = parseFloat(getComputedStyle(aside).getPropertyValue('--cd-sticky-top')) || 130;
      var h = aside.offsetHeight;
      var vh = window.innerHeight;
      var top = h + base + 20 > vh ? vh - h - 20 : base;
      aside.style.setProperty('--cd-top', Math.round(top) + 'px');
    }

    function schedule() {
      if (!frame) frame = requestAnimationFrame(measure);
    }

    new ResizeObserver(schedule).observe(aside);
    window.addEventListener('resize', schedule, { passive: true });
    measure();
  }

  /* ---------- Hero video: play only while on screen ---------- */
  function initVideo(section) {
    section.querySelectorAll('.b-cd__hero video').forEach(function (video) {
      if (video.dataset.bCdBound) return;
      video.dataset.bCdBound = '1';
      video.muted = true;
      if (reduceMotion || !('IntersectionObserver' in window)) {
        video.controls = true;
        return;
      }
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.2 }
      ).observe(video);
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-b-cd]').forEach(function (section) {
      section.querySelectorAll('[data-b-cd-tabs]').forEach(initTabs);
      initAside(section);
      initVideo(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target && e.target.id ? document.querySelector('[aria-controls="' + e.target.id + '"]') : null;
    if (tab) tab.click();
  });
})();
